// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a4a7f59a","581":"059be49d"}[chunkId] + ".chunk.js";
};